// source/js/modules/page-loaded.js
const initializePageLoaded = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const addLoaded = () => {
    if (document.body && !document.body.classList.contains('is-loaded')) {
      document.body.classList.add('is-loaded');
    }
  };

  // 既にロード済みなら即時適用
  if (document.readyState === 'complete') {
    addLoaded();
    return;
  }

  // フォールバック（2.5秒で強制的に表示）
  const MAX_WAIT_MS = 2500;
  const timeoutId = window.setTimeout(addLoaded, MAX_WAIT_MS);

  // ページの全リソース読み込み完了で適用し、フォールバックを解除
  window.addEventListener(
    'load',
    () => {
      window.clearTimeout(timeoutId);
      addLoaded();
    },
    { once: true },
  );
};

export { initializePageLoaded };
